import { useEffect, useState, useRef } from "react";
import { Button, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

//Services
import api from "@/services/api.service";
import { FETCH_UPDATES_SUCCESS } from "@/redux/types/updates.types";
import _ from "lodash";

//Styles
import classes from "./updates.module.scss";

//Components
import Fetching from "@/components/Fetching/Fetching";
import Head from "@/components/Content/Head";
import Update from "./components/Update";
import UpdateForm from "./Form/UpdateForm";

const Updates = () => {
	const dispatch = useDispatch();
	const listInnerRef = useRef(null);
	const user = JSON.parse(localStorage.getItem("superuser"));
	const { loading, updates } = useSelector((state) => state.update);

	const [addForm, setAddForm] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [lastPage, setLastPage] = useState(1);
	const [tools, setTools] = useState([]);

	const handleClose = () => {
		setAddForm(false);
	};

	const handleAddModal = () => {
		setAddForm(true);
	};

	const onScroll = () => {
		if (listInnerRef.current) {
			const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;

			if (_.round(scrollTop + clientHeight) === scrollHeight) {
				setCurrentPage(currentPage + 1);
			}
		}
	};

	useEffect(() => {
		if (currentPage <= lastPage) {
			api.get("/admin/updates", { page: currentPage }).then((response) => {
				let newUpdate = updates && currentPage !== 1 ? [...updates] : [];
				response.updates.data.forEach((element) => {
					newUpdate.push(element);
				});

				setLastPage(response && response.updates && response.updates.last_page);
				setTools(response && response.tools ? response.tools : []);

				dispatch({
					type: FETCH_UPDATES_SUCCESS,
					payload: {
						updates: newUpdate,
					},
				});
			});
		}
		// eslint-disable-next-line
	}, [dispatch, currentPage]);

	return (
		<>
			<Head title="Historial de actualizaciones"></Head>

			<Row className={classes.updates_main}>
				<Col md={12} className={`${classes.main_content}`}>
					{user === 1 && (
						<Row md={10} className={`${classes.title_container}`}>
							<Col md={12}>
								<Button size="sm" onClick={handleAddModal}>
									Agregar Actualizacion
								</Button>
							</Col>
						</Row>
					)}

					<div className={`${classes.content_container}`} onScroll={(e) => onScroll(e)} ref={listInnerRef}>
						<>
							{updates &&
								updates.map((update, index) => {
									return (
										<Update
											key={index}
											post_id={update.post_id}
											created_at={update.created_at}
											title={update.title}
											update_tools={update.tools}
											description={update.updates_detail[0].description && update.updates_detail[0].description}
											detail_id={update.updates_detail[0].id && update.updates_detail[0].id}
											userName={update.user_name}
											photo={update.photo}
											linkedin={update.linkedin}
											whatsapp={update.whatsapp}
											publish={update.publish}
											tools={tools}
										/>
									);
								})}
						</>
						{loading && <Fetching topMargin={"0px"} />}
					</div>
				</Col>
				<UpdateForm show={addForm} handleClose={handleClose} setAddForm={setAddForm} page={currentPage} setPage={setCurrentPage} tools={tools} />
			</Row>
		</>
	);
};

export default Updates;
